import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AsideComponent } from './aside.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        AsideComponent, NavbarComponent,
    ],
    exports: [
        AsideComponent,
        NavbarComponent
    ],
    providers: []
})
export class AsideModule { }
